import { apiFetch } from '@app/utils/utils';
import { AdminDriverSummary, AdminDriverDetail } from '@app/Drivers/types';

const BASE = '/api/admin/drivers';

export async function getDrivers(opts: {
  q?: string;
  available?: boolean;
  limit?: number;
  offset?: number;
} = {}): Promise<AdminDriverSummary[]> {
  const params = new URLSearchParams();
  if (opts.q) params.set('q', opts.q);
  if (opts.available != null) params.set('available', String(opts.available));
  if (opts.limit != null) params.set('limit', String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load drivers (${res.status})`);
  return res.json();
}

export async function getDriver(id: number): Promise<AdminDriverDetail> {
  const res = await apiFetch(`${BASE}/${id}`);
  if (res.status === 404) throw new Error('Driver not found');
  if (!res.ok) throw new Error(`Failed to load driver (${res.status})`);
  return res.json();
}
